/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as CheckEmailRouteImport } from './routes/check-email'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignedInRouteImport } from './routes/signed-in'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AdminInvitationsTokenRouteImport } from './routes/admin-invitations.$token'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AdminJobsRouteImport } from './routes/admin/jobs'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as BusinessesSlugRouteImport } from './routes/businesses/$slug'
import { Route as BusinessesRegisterRouteImport } from './routes/businesses/register'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardBusinessSlugRouteRouteImport } from './routes/dashboard/$businessSlug/route'
import { Route as InvitationsTokenRouteImport } from './routes/invitations.$token'
import { Route as JobsIndexRouteImport } from './routes/jobs/index'
import { Route as SettingsAccountRouteImport } from './routes/settings/account'
import { Route as AdminBusinessesIndexRouteImport } from './routes/admin/businesses/index'
import { Route as AdminBusinessesBusinessIdRouteImport } from './routes/admin/businesses/$businessId'
import { Route as BusinessesRegisteredBusinessSlugRouteImport } from './routes/businesses/registered.$businessSlug'
import { Route as DashboardBusinessSlugIndexRouteImport } from './routes/dashboard/$businessSlug/index'
import { Route as DashboardBusinessSlugSettingsRouteImport } from './routes/dashboard/$businessSlug/settings'
import { Route as DashboardBusinessSlugTeamRouteImport } from './routes/dashboard/$businessSlug/team'
import { Route as JobsBusinessSlugJobSlugRouteImport } from './routes/jobs/$businessSlug.$jobSlug'
import { Route as DashboardBusinessSlugJobsIndexRouteImport } from './routes/dashboard/$businessSlug/jobs/index'
import { Route as DashboardBusinessSlugJobsJobIdRouteImport } from './routes/dashboard/$businessSlug/jobs/$jobId'
import { Route as DashboardBusinessSlugJobsNewRouteImport } from './routes/dashboard/$businessSlug/jobs/new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckEmailRoute = CheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedInRoute = SignedInRouteImport.update({
  id: '/signed-in',
  path: '/signed-in',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminInvitationsTokenRoute = AdminInvitationsTokenRouteImport.update({
  id: '/admin-invitations/$token',
  path: '/admin-invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminJobsRoute = AdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const BusinessesSlugRoute = BusinessesSlugRouteImport.update({
  id: '/businesses/$slug',
  path: '/businesses/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessesRegisterRoute = BusinessesRegisterRouteImport.update({
  id: '/businesses/register',
  path: '/businesses/register',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBusinessSlugRouteRoute =
  DashboardBusinessSlugRouteRouteImport.update({
    id: '/$businessSlug',
    path: '/$businessSlug',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const AdminBusinessesIndexRoute = AdminBusinessesIndexRouteImport.update({
  id: '/businesses/',
  path: '/businesses/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBusinessesBusinessIdRoute =
  AdminBusinessesBusinessIdRouteImport.update({
    id: '/businesses/$businessId',
    path: '/businesses/$businessId',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const BusinessesRegisteredBusinessSlugRoute =
  BusinessesRegisteredBusinessSlugRouteImport.update({
    id: '/businesses/registered/$businessSlug',
    path: '/businesses/registered/$businessSlug',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardBusinessSlugIndexRoute =
  DashboardBusinessSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardBusinessSlugRouteRoute,
  } as any)
const DashboardBusinessSlugSettingsRoute =
  DashboardBusinessSlugSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardBusinessSlugRouteRoute,
  } as any)
const DashboardBusinessSlugTeamRoute =
  DashboardBusinessSlugTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => DashboardBusinessSlugRouteRoute,
  } as any)
const JobsBusinessSlugJobSlugRoute = JobsBusinessSlugJobSlugRouteImport.update({
  id: '/jobs/$businessSlug/$jobSlug',
  path: '/jobs/$businessSlug/$jobSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardBusinessSlugJobsIndexRoute =
  DashboardBusinessSlugJobsIndexRouteImport.update({
    id: '/jobs/',
    path: '/jobs/',
    getParentRoute: () => DashboardBusinessSlugRouteRoute,
  } as any)
const DashboardBusinessSlugJobsJobIdRoute =
  DashboardBusinessSlugJobsJobIdRouteImport.update({
    id: '/jobs/$jobId',
    path: '/jobs/$jobId',
    getParentRoute: () => DashboardBusinessSlugRouteRoute,
  } as any)
const DashboardBusinessSlugJobsNewRoute =
  DashboardBusinessSlugJobsNewRouteImport.update({
    id: '/jobs/new',
    path: '/jobs/new',
    getParentRoute: () => DashboardBusinessSlugRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/check-email': typeof CheckEmailRoute
  '/contact': typeof ContactRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/signed-in': typeof SignedInRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/dashboard/$businessSlug': typeof DashboardBusinessSlugRouteRouteWithChildren
  '/admin-invitations/$token': typeof AdminInvitationsTokenRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/users': typeof AdminUsersRoute
  '/businesses/$slug': typeof BusinessesSlugRoute
  '/businesses/register': typeof BusinessesRegisterRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/settings/account': typeof SettingsAccountRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/admin/businesses/$businessId': typeof AdminBusinessesBusinessIdRoute
  '/businesses/registered/$businessSlug': typeof BusinessesRegisteredBusinessSlugRoute
  '/dashboard/$businessSlug/settings': typeof DashboardBusinessSlugSettingsRoute
  '/dashboard/$businessSlug/team': typeof DashboardBusinessSlugTeamRoute
  '/jobs/$businessSlug/$jobSlug': typeof JobsBusinessSlugJobSlugRoute
  '/admin/businesses/': typeof AdminBusinessesIndexRoute
  '/dashboard/$businessSlug/': typeof DashboardBusinessSlugIndexRoute
  '/dashboard/$businessSlug/jobs/$jobId': typeof DashboardBusinessSlugJobsJobIdRoute
  '/dashboard/$businessSlug/jobs/new': typeof DashboardBusinessSlugJobsNewRoute
  '/dashboard/$businessSlug/jobs/': typeof DashboardBusinessSlugJobsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/check-email': typeof CheckEmailRoute
  '/contact': typeof ContactRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/signed-in': typeof SignedInRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin-invitations/$token': typeof AdminInvitationsTokenRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/users': typeof AdminUsersRoute
  '/businesses/$slug': typeof BusinessesSlugRoute
  '/businesses/register': typeof BusinessesRegisterRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/settings/account': typeof SettingsAccountRoute
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/jobs': typeof JobsIndexRoute
  '/admin/businesses/$businessId': typeof AdminBusinessesBusinessIdRoute
  '/businesses/registered/$businessSlug': typeof BusinessesRegisteredBusinessSlugRoute
  '/dashboard/$businessSlug/settings': typeof DashboardBusinessSlugSettingsRoute
  '/dashboard/$businessSlug/team': typeof DashboardBusinessSlugTeamRoute
  '/jobs/$businessSlug/$jobSlug': typeof JobsBusinessSlugJobSlugRoute
  '/admin/businesses': typeof AdminBusinessesIndexRoute
  '/dashboard/$businessSlug': typeof DashboardBusinessSlugIndexRoute
  '/dashboard/$businessSlug/jobs/$jobId': typeof DashboardBusinessSlugJobsJobIdRoute
  '/dashboard/$businessSlug/jobs/new': typeof DashboardBusinessSlugJobsNewRoute
  '/dashboard/$businessSlug/jobs': typeof DashboardBusinessSlugJobsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/check-email': typeof CheckEmailRoute
  '/contact': typeof ContactRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/signed-in': typeof SignedInRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/dashboard/$businessSlug': typeof DashboardBusinessSlugRouteRouteWithChildren
  '/admin-invitations/$token': typeof AdminInvitationsTokenRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/users': typeof AdminUsersRoute
  '/businesses/$slug': typeof BusinessesSlugRoute
  '/businesses/register': typeof BusinessesRegisterRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/settings/account': typeof SettingsAccountRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/admin/businesses/$businessId': typeof AdminBusinessesBusinessIdRoute
  '/businesses/registered/$businessSlug': typeof BusinessesRegisteredBusinessSlugRoute
  '/dashboard/$businessSlug/settings': typeof DashboardBusinessSlugSettingsRoute
  '/dashboard/$businessSlug/team': typeof DashboardBusinessSlugTeamRoute
  '/jobs/$businessSlug/$jobSlug': typeof JobsBusinessSlugJobSlugRoute
  '/admin/businesses/': typeof AdminBusinessesIndexRoute
  '/dashboard/$businessSlug/': typeof DashboardBusinessSlugIndexRoute
  '/dashboard/$businessSlug/jobs/$jobId': typeof DashboardBusinessSlugJobsJobIdRoute
  '/dashboard/$businessSlug/jobs/new': typeof DashboardBusinessSlugJobsNewRoute
  '/dashboard/$businessSlug/jobs/': typeof DashboardBusinessSlugJobsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/settings'
    | '/about'
    | '/check-email'
    | '/contact'
    | '/forgot-password'
    | '/privacy'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/signed-in'
    | '/terms'
    | '/verify-email'
    | '/dashboard/$businessSlug'
    | '/admin-invitations/$token'
    | '/admin/audit'
    | '/admin/jobs'
    | '/admin/users'
    | '/businesses/$slug'
    | '/businesses/register'
    | '/invitations/$token'
    | '/settings/account'
    | '/admin/'
    | '/dashboard/'
    | '/jobs/'
    | '/admin/businesses/$businessId'
    | '/businesses/registered/$businessSlug'
    | '/dashboard/$businessSlug/settings'
    | '/dashboard/$businessSlug/team'
    | '/jobs/$businessSlug/$jobSlug'
    | '/admin/businesses/'
    | '/dashboard/$businessSlug/'
    | '/dashboard/$businessSlug/jobs/$jobId'
    | '/dashboard/$businessSlug/jobs/new'
    | '/dashboard/$businessSlug/jobs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/settings'
    | '/about'
    | '/check-email'
    | '/contact'
    | '/forgot-password'
    | '/privacy'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/signed-in'
    | '/terms'
    | '/verify-email'
    | '/admin-invitations/$token'
    | '/admin/audit'
    | '/admin/jobs'
    | '/admin/users'
    | '/businesses/$slug'
    | '/businesses/register'
    | '/invitations/$token'
    | '/settings/account'
    | '/admin'
    | '/dashboard'
    | '/jobs'
    | '/admin/businesses/$businessId'
    | '/businesses/registered/$businessSlug'
    | '/dashboard/$businessSlug/settings'
    | '/dashboard/$businessSlug/team'
    | '/jobs/$businessSlug/$jobSlug'
    | '/admin/businesses'
    | '/dashboard/$businessSlug'
    | '/dashboard/$businessSlug/jobs/$jobId'
    | '/dashboard/$businessSlug/jobs/new'
    | '/dashboard/$businessSlug/jobs'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/dashboard'
    | '/settings'
    | '/about'
    | '/check-email'
    | '/contact'
    | '/forgot-password'
    | '/privacy'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/signed-in'
    | '/terms'
    | '/verify-email'
    | '/dashboard/$businessSlug'
    | '/admin-invitations/$token'
    | '/admin/audit'
    | '/admin/jobs'
    | '/admin/users'
    | '/businesses/$slug'
    | '/businesses/register'
    | '/invitations/$token'
    | '/settings/account'
    | '/admin/'
    | '/dashboard/'
    | '/jobs/'
    | '/admin/businesses/$businessId'
    | '/businesses/registered/$businessSlug'
    | '/dashboard/$businessSlug/settings'
    | '/dashboard/$businessSlug/team'
    | '/jobs/$businessSlug/$jobSlug'
    | '/admin/businesses/'
    | '/dashboard/$businessSlug/'
    | '/dashboard/$businessSlug/jobs/$jobId'
    | '/dashboard/$businessSlug/jobs/new'
    | '/dashboard/$businessSlug/jobs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  CheckEmailRoute: typeof CheckEmailRoute
  ContactRoute: typeof ContactRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  SignedInRoute: typeof SignedInRoute
  TermsRoute: typeof TermsRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AdminInvitationsTokenRoute: typeof AdminInvitationsTokenRoute
  BusinessesSlugRoute: typeof BusinessesSlugRoute
  BusinessesRegisterRoute: typeof BusinessesRegisterRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
  JobsIndexRoute: typeof JobsIndexRoute
  BusinessesRegisteredBusinessSlugRoute: typeof BusinessesRegisteredBusinessSlugRoute
  JobsBusinessSlugJobSlugRoute: typeof JobsBusinessSlugJobSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-email': {
      id: '/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof CheckEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-in': {
      id: '/signed-in'
      path: '/signed-in'
      fullPath: '/signed-in'
      preLoaderRoute: typeof SignedInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-invitations/$token': {
      id: '/admin-invitations/$token'
      path: '/admin-invitations/$token'
      fullPath: '/admin-invitations/$token'
      preLoaderRoute: typeof AdminInvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/jobs': {
      id: '/admin/jobs'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AdminJobsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/businesses/$slug': {
      id: '/businesses/$slug'
      path: '/businesses/$slug'
      fullPath: '/businesses/$slug'
      preLoaderRoute: typeof BusinessesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/businesses/register': {
      id: '/businesses/register'
      path: '/businesses/register'
      fullPath: '/businesses/register'
      preLoaderRoute: typeof BusinessesRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/$businessSlug': {
      id: '/dashboard/$businessSlug'
      path: '/$businessSlug'
      fullPath: '/dashboard/$businessSlug'
      preLoaderRoute: typeof DashboardBusinessSlugRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/invitations/$token': {
      id: '/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/admin/businesses/': {
      id: '/admin/businesses/'
      path: '/businesses'
      fullPath: '/admin/businesses/'
      preLoaderRoute: typeof AdminBusinessesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/businesses/$businessId': {
      id: '/admin/businesses/$businessId'
      path: '/businesses/$businessId'
      fullPath: '/admin/businesses/$businessId'
      preLoaderRoute: typeof AdminBusinessesBusinessIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/businesses/registered/$businessSlug': {
      id: '/businesses/registered/$businessSlug'
      path: '/businesses/registered/$businessSlug'
      fullPath: '/businesses/registered/$businessSlug'
      preLoaderRoute: typeof BusinessesRegisteredBusinessSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/$businessSlug/': {
      id: '/dashboard/$businessSlug/'
      path: '/'
      fullPath: '/dashboard/$businessSlug/'
      preLoaderRoute: typeof DashboardBusinessSlugIndexRouteImport
      parentRoute: typeof DashboardBusinessSlugRouteRoute
    }
    '/dashboard/$businessSlug/settings': {
      id: '/dashboard/$businessSlug/settings'
      path: '/settings'
      fullPath: '/dashboard/$businessSlug/settings'
      preLoaderRoute: typeof DashboardBusinessSlugSettingsRouteImport
      parentRoute: typeof DashboardBusinessSlugRouteRoute
    }
    '/dashboard/$businessSlug/team': {
      id: '/dashboard/$businessSlug/team'
      path: '/team'
      fullPath: '/dashboard/$businessSlug/team'
      preLoaderRoute: typeof DashboardBusinessSlugTeamRouteImport
      parentRoute: typeof DashboardBusinessSlugRouteRoute
    }
    '/jobs/$businessSlug/$jobSlug': {
      id: '/jobs/$businessSlug/$jobSlug'
      path: '/jobs/$businessSlug/$jobSlug'
      fullPath: '/jobs/$businessSlug/$jobSlug'
      preLoaderRoute: typeof JobsBusinessSlugJobSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/$businessSlug/jobs/': {
      id: '/dashboard/$businessSlug/jobs/'
      path: '/jobs'
      fullPath: '/dashboard/$businessSlug/jobs/'
      preLoaderRoute: typeof DashboardBusinessSlugJobsIndexRouteImport
      parentRoute: typeof DashboardBusinessSlugRouteRoute
    }
    '/dashboard/$businessSlug/jobs/$jobId': {
      id: '/dashboard/$businessSlug/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/dashboard/$businessSlug/jobs/$jobId'
      preLoaderRoute: typeof DashboardBusinessSlugJobsJobIdRouteImport
      parentRoute: typeof DashboardBusinessSlugRouteRoute
    }
    '/dashboard/$businessSlug/jobs/new': {
      id: '/dashboard/$businessSlug/jobs/new'
      path: '/jobs/new'
      fullPath: '/dashboard/$businessSlug/jobs/new'
      preLoaderRoute: typeof DashboardBusinessSlugJobsNewRouteImport
      parentRoute: typeof DashboardBusinessSlugRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAuditRoute: typeof AdminAuditRoute
  AdminJobsRoute: typeof AdminJobsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminBusinessesBusinessIdRoute: typeof AdminBusinessesBusinessIdRoute
  AdminBusinessesIndexRoute: typeof AdminBusinessesIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAuditRoute: AdminAuditRoute,
  AdminJobsRoute: AdminJobsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminBusinessesBusinessIdRoute: AdminBusinessesBusinessIdRoute,
  AdminBusinessesIndexRoute: AdminBusinessesIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface DashboardBusinessSlugRouteRouteChildren {
  DashboardBusinessSlugSettingsRoute: typeof DashboardBusinessSlugSettingsRoute
  DashboardBusinessSlugTeamRoute: typeof DashboardBusinessSlugTeamRoute
  DashboardBusinessSlugIndexRoute: typeof DashboardBusinessSlugIndexRoute
  DashboardBusinessSlugJobsJobIdRoute: typeof DashboardBusinessSlugJobsJobIdRoute
  DashboardBusinessSlugJobsNewRoute: typeof DashboardBusinessSlugJobsNewRoute
  DashboardBusinessSlugJobsIndexRoute: typeof DashboardBusinessSlugJobsIndexRoute
}

const DashboardBusinessSlugRouteRouteChildren: DashboardBusinessSlugRouteRouteChildren =
  {
    DashboardBusinessSlugSettingsRoute: DashboardBusinessSlugSettingsRoute,
    DashboardBusinessSlugTeamRoute: DashboardBusinessSlugTeamRoute,
    DashboardBusinessSlugIndexRoute: DashboardBusinessSlugIndexRoute,
    DashboardBusinessSlugJobsJobIdRoute: DashboardBusinessSlugJobsJobIdRoute,
    DashboardBusinessSlugJobsNewRoute: DashboardBusinessSlugJobsNewRoute,
    DashboardBusinessSlugJobsIndexRoute: DashboardBusinessSlugJobsIndexRoute,
  }

const DashboardBusinessSlugRouteRouteWithChildren =
  DashboardBusinessSlugRouteRoute._addFileChildren(
    DashboardBusinessSlugRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardBusinessSlugRouteRoute: typeof DashboardBusinessSlugRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardBusinessSlugRouteRoute: DashboardBusinessSlugRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  CheckEmailRoute: CheckEmailRoute,
  ContactRoute: ContactRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  SignedInRoute: SignedInRoute,
  TermsRoute: TermsRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AdminInvitationsTokenRoute: AdminInvitationsTokenRoute,
  BusinessesSlugRoute: BusinessesSlugRoute,
  BusinessesRegisterRoute: BusinessesRegisterRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
  JobsIndexRoute: JobsIndexRoute,
  BusinessesRegisteredBusinessSlugRoute: BusinessesRegisteredBusinessSlugRoute,
  JobsBusinessSlugJobSlugRoute: JobsBusinessSlugJobSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
